module.exports = __webpack_public_path__ + "media/images/lb/451-12128ebe45defe749073bc600ff1b727.svg";